export default __webpack_public_path__ + "static/1790-98d6c6a32ffd46bed231a9616d864ebd.gif";